import React, { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
  [{ align: [] }],
  ["link", "clean"],
];

export default function QuillRichText({ value = "", onChange, placeholder = "" }) {
  const containerRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || quillRef.current) return;

    quillRef.current = new Quill(containerRef.current, {
      theme: "snow",
      placeholder,
      modules: { toolbar: TOOLBAR },
    });

    quillRef.current.on("text-change", () => {
      const html = quillRef.current.root.innerHTML;
      onChange && onChange(html);
    });

    // valeur initiale
    if (value) {
      quillRef.current.clipboard.dangerouslyPasteHTML(value);
    }
  }, []);

  // synchronise quand value change depuis le parent
  useEffect(() => {
    const quill = quillRef.current;
    if (!quill) return;
    const current = quill.root.innerHTML;
    if (value != null && value !== current) {
      quill.clipboard.dangerouslyPasteHTML(value || "");
    }
  }, [value]);

  return <div className="quill-dark"><div ref={containerRef} /></div>;
}
